import { render, staticRenderFns } from "./CashClosings.vue?vue&type=template&id=b876c048&scoped=true&"
import script from "./CashClosings.vue?vue&type=script&lang=js&"
export * from "./CashClosings.vue?vue&type=script&lang=js&"
import style0 from "./CashClosings.vue?vue&type=style&index=0&id=b876c048&prod&lang=scss&scoped=true&"
import style1 from "./CashClosings.vue?vue&type=style&index=1&id=b876c048&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b876c048",
  null
  
)

export default component.exports